import React, { Component } from 'react'
import "src/assets/css/dashboard.css";

import TableLoader from "src/TableLoader";
import PythonService from "src/api/PythonService";

import Select2 from './components/Action/Select2'
import Product from './components/Action/Product'
import Select2Multi from './components/Action/Select2Multi_olk'
import Periods from './components/Action/Period'
import LocationAttribute from './components/Action/LocationAttribute'
import ProductAttribute from './components/Action/ProductAttribute'
import RangeLocation from "./components/range/RangeLocation";
import RangeProduct from "./components/range/RangeProduct";
import { Row } from "reactstrap";
import "src/assets/css/fullapp.css";
import { connect } from 'react-redux';
import { updateFilterData,setProducts ,setLocations,setPeriods,setLocationAtt, setProductAtt} from 'src/redux/actions';
export class Filter extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
     isFetching: true,
     isPeriodlblist:true,
     isPeriodllist:true,
     isproductAttribute:true,
     islocationAttribute:true,
     form:[],
     prod:[],
     all_period_list:[],
     periodllist:[],
     periodlblist:"",
     productAttribute:"",
     locationAttribute:"",
     loc:[],
     slec:0,
     ProdSet:{},
     LocSet:{},
     period_bucket:{},
     period_list:{},
     productAttributeList:{},
     locationAttributeList:{},
     ProdSlider:[],
     LocSlider:[],
     defaultSelection:null,
     SLoc:1,
     SProd:1,
     productSize:'3',
     locationSize:'3',
     periodSize:'3',
     bucketSize:'3',
     productAttSize:'3',
     locationAttSize:'3',

    }

    this.FilterFnc = this.FilterFnc.bind(this);
    this.ProdHire = this.ProdHire.bind(this);
    this.LocHire = this.LocHire.bind(this);

   }


   async getField(){

    await PythonService.get(
      "filters/"+this.props.client_id+"/"
      +this.props.user_id+"/"
      +this.props.module_id+"/"
      +this.props.scenario_id,
      (status,data)=>{
      let SProd= data['product-level']['default-value'];
      let SLoc=data['location-from-level']['default-value'];
     var ProdSet={}
     let allProducts = []



     data['product-list']['data'].map(item=>{
       ProdSet[item['key']]=item['value'];
       allProducts.push(item['key']);
     })
     this.props.setProducts(allProducts);

     var LocSet={}
     let allLocations = []
     data['location-from-list']['data'].map(item=>{
       LocSet[item['key']]=item['value'];
       allLocations.push(item['key']);
     })
     this.props.setLocations(allLocations);

     var period_bucket={}
     let all_period_bucket = []
     data['period-bucket-list']['data'].map(item=>{
      period_bucket[item['key']]=item['value'];
      all_period_bucket.push(item['key']);
     })
     

     var period_list={}
     let all_period_list = []
     data['period-list']['data'].map(item=>{
      period_list[item['key']]=item['value'];
      all_period_list.push(item['key']+"");
     })
     this.props.setPeriods(all_period_list)
  
     var locationAttributeList={}
     let alllocationAttributelist = []
     data['location-attribute']['data'].map(item=>{
      locationAttributeList[item['key']]=item['value'];
      alllocationAttributelist.push(item['key']+"");
     })
     this.props.setLocationAtt(alllocationAttributelist)

     var productAttributeList={}
     let allproductAttributelist = []
     data['product-attribute']['data'].map(item=>{
      productAttributeList[item['key']]=item['value'];
      allproductAttributelist.push(item['key']+"");
     })   

     this.props.setProductAtt(allproductAttributelist)

       if(status==200){
        var data=JSON.stringify(data);
         data= JSON.parse(data);

         this.setState({
          form:data,
          ProdSet:ProdSet,
          LocSet:LocSet,
          period_bucket:period_bucket,
          period_list:period_list,
          SProd:SProd,
          SLoc:SLoc,
          locationAttributeList:locationAttributeList,
          productAttributeList:productAttributeList,

          periodlblist:data['period-bucket-list']['default-value'],
          locationAttribute:data['location-attribute']['default-value'],
          productAttribute:data['product-attribute']['default-value'],
          isPeriodlblist:data['period-bucket-list']['enable'],
          isproductAttribute:data['product-attribute']['enable'],
          islocationAttribute:data['location-attribute']['enable'],
          periodllist:data['period-list']['default-value'],
          isPeriodllist:data['period-list']['enable'],
          productSize:data['product-list']['size'],
          locationSize:data['location-from-list']['size'],
          periodSize:data['period-list']['size'],
          bucketSize:data['period-bucket-list']['size'],
          productAttSize:data['product-attribute']['size'],
          locationAttSize:data['location-attribute']['size'],
          all_period_list:all_period_list,
          loc:allLocations,
          prod:allProducts,
          isFetching:false
        })

       }
   });   
 }


  componentDidMount(){

  
      if(this.props.refreshFilterField){
        this.getField();
      }else{
        var data = { ...this.props.filterData };      
        data['form']['product-level']['default-value'] = data['SProd'];
        data['form']['location-from-level']['default-value'] = data['SLoc'];
        data['form']['product-list']['default-value'] = data['ProdSet'];
        data['form']['location-from-list']['default-value'] = data['LocSet'];
        data['form']['period-bucket-list']['default-value'] = data['periodlblist'];
        this.setState(data);
      }
    }
   



FilterFnc(){
  var products = { ...this.props.products };
  var locations = { ...this.props.locations };
  var periods = { ...this.props.periods };
  var location_att = { ...this.props.location_att };
  var product_att = { ...this.props.product_att };

  var data={
    'client-id':this.props.client_id,
    'module-id':this.props.module_id,
    'scenario-id':this.props.scenario_id,
    'user-id':this.props.user_id,
    'selected-product-level':this.state.SProd,
    'selected-location-from-level':this.state.SLoc,
    'selected-period-type':this.state.periodlblist,
    'selected-location-from-list':Object.values(locations),
    'selected-product-list':Object.values(products),
    'selected-period-list':Object.values(periods),
    'selected-location-attribute-list':Object.values(location_att),
    'selected-product-attribute-list':Object.values(product_att),
    'filter':true
  }


  this.props.updateFilterData(this.state);
  this.props.onChange(data);
}

objectToFormData(object) {
  const formData = new FormData();

  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      formData.append(key, object[key]);
    }
  }

  return formData;
}

PeriodList(e){
  const obj = {
    'period_data': e.code,
    'client-id': parseInt(this.props.client_id),
    'module-id': parseInt(this.props.module_id),
    'scenario-id': parseInt(this.props.scenario_id),
    'user-id': parseInt(this.props.user_id)
  };
  PythonService.post("period-data",obj,(status,data)=>{

    if(status==200){               
      var period_list={}
      let all_period_list = []
      data.map(item=>{
        period_list[item['key']]=item['value'];
        all_period_list.push(item['key']+"");
      })
       this.props.setPeriods(all_period_list);
       this.setState({
        period_list:period_list,   
      })
    }else if(status==400){      

    }
    });
}

ProdHire(e) {
  const obj = {
    'selected-product-level': parseInt(e),
    'client-id': parseInt(this.props.client_id),
    'module-id': parseInt(this.props.module_id),
    'scenario-id': parseInt(this.props.scenario_id),
    'user-id': parseInt(this.props.user_id)
  };


  PythonService.post("product-data", obj, (status, data) => {
    if (status === 200) {
      const ProdSet = {};
      const allProducts = [];

      data.forEach(item => {
        ProdSet[item['key']] = item['value'];
        allProducts.push(item['key']);
      });
      this.props.setProducts(allProducts);
      this.setState({
        ProdSet: ProdSet,
        // prod: allProducts
      });
    } else if (status === 400) {
      // Handle 400 status here
    }
  });
}


LocHire(e){
  var obj = {};
  obj['selected-location-from-level']= e;
  obj['client-id']=this.props.client_id,
  obj['module-id']=this.props.module_id,
  obj['scenario-id']=this.props.scenario_id,
  obj['user-id']=this.props.user_id,
  PythonService.post("location-from-data",obj,(status,data)=>{
    if(status==200){           
     
      var LocSet={}
      let allLocations = []
      data.map(item=>{
        LocSet[item['key']]=item['value'];
        allLocations.push(item['key']);
      })
      this.props.setLocations(allLocations);
      this.setState({
        LocSet:LocSet,
    
      })
    }else if(status==400){ 
      

      
    }
    });
}
  render(){
if(this.state.isFetching){
  return (<div><center><TableLoader message={"take a breath"}/></center></div>);
}



    return (
      <>     
              
        <div className='filter_card' >      
         
         <Row>
          <div className='col-sm' style={{marginLeft:'2%'}}>
            <RangeProduct
              client_id={this.props.client_id}
              module_id={this.props.module_id}
              scenario_id={this.props.scenario_id}
              user_id={this.props.user_id}
              form={this.state.form}
                 modify={this.state.SProd}
                 value={this.state.prod}
                 ProdSlider={(e)=>{                  
                  this.setState({
                    ProdSlider:e,                    
                  })
                 }}
                   onChange={(e)=>{         
                    if(e==this.state.SProd){
                      this.setState({
                        SProd:e,                               
                      });
                    }else{
                      this.setState({
                        SProd:e,     
                        prod:[],               
                      });
                     this.ProdHire(e);
                    }

                     }
                   }/> 

          </div>
          <div className='col-sm' style={{marginLeft:'3%'}}>
           <RangeLocation 
            client_id={this.props.client_id}
            form={this.state.form}
            module_id={this.props.module_id}
            scenario_id={this.props.scenario_id}
            user_id={this.props.user_id}
           value={this.state.loc}
           LocSlider={(e)=>{            
            this.setState({
              LocSlider:e
            })
           }}
            modify={this.state.SLoc}
                       onChange={(e)=>{
                        if(e==this.state.SLoc){
                          this.setState({
                            SLoc:e,                            
                         })
                        }else{
                          this.setState({
                            SLoc:e,
                            loc:[],            
                         })
                         this.LocHire(e);
                        }

                       
                    }
                  }
                   /> 
          </div>
        </Row>
      
        <Row style={{textAlign: 'left' }}>

            <div className={`col-lg-${this.state.productSize} my-auto top_select`}  style={{fontFamily: 'sans-serif !important'}}>
            <Product 
                    id="prod"
                    label="Product"
                    value={this.state.prod}
                    remote_source={Object.keys(this.state.ProdSet).length ==0 ?[]:this.state.ProdSet}                 

                    />
            </div>    
  
            <div className={`col-lg-${this.state.locationSize} my-auto top_select`} style={{fontFamily: 'sans-serif !important'}} >
               <Select2Multi 
                    id="loc"
                    value={this.state.loc}
                    remote_source={Object.keys(this.state.LocSet).length ==0 ?[]:this.state.LocSet}
                    error={[]}
                    label="Location"
                   />
            </div> 

            {this.state.isPeriodlblist?<div className={`col-lg-${this.state.bucketSize} my-auto top_select`} style={{fontFamily: 'sans-serif !important',textAlign: 'left'}}>
             <Select2 
                    id="prod_bucket"
                    label="Period Bucket"
                    value={this.state.periodlblist}
                    remote_source={Object.keys(this.state.period_bucket).length ==0 ?[]:this.state.period_bucket}
                    validation=""
                    error={[]}
                    onChange={(e)=>{                   

                      this.setState(
                        {
                          periodlblist:e.name,
                          all_period_list:[]
                        }
                      );
                      this.PeriodList(e);
                    }}
                    />
            </div>:''}
            {this.state.isPeriodllist?
            <div className={`col-lg-${this.state.periodSize} my-auto top_select`} style={{fontFamily: 'sans-serif !important',textAlign: 'left'}}>
             <Periods 
                    id="period_list"
                    label="Period"
                    value={this.state.periodllist}
                    remote_source={Object.keys(this.state.period_list).length ==0 ?[]:this.state.period_list}
                    />
            </div>  :''}

            {this.state.isproductAttribute?
            <div className={`col-lg-${this.state.productAttSize} my-auto top_select`} style={{fontFamily: 'sans-serif !important',textAlign: 'left' }}>
             <ProductAttribute 
                    id="product_attribute"
                    label="Product Attribute"
                    value={this.state.productAttribute}
                    remote_source={Object.keys(this.state.productAttributeList).length ==0 ?[]:this.state.productAttributeList}
                    validation=""
                    error={[]}
                    onChange={(e)=>{                   

                    }}
                    />
            </div>:''}
            {this.state.islocationAttribute?
            <div className={`col-lg-${this.state.locationAttSize} my-auto top_select`} style={{fontFamily: 'sans-serif !important',textAlign: 'left' }}>
             <LocationAttribute 
                    id="location_attribute"
                    label="Location Attribute"
                    value={this.state.locationAttribute}
                    remote_source={Object.keys(this.state.locationAttributeList).length ==0 ?[]:this.state.locationAttributeList}
                    validation=""
                    error={[]}
                    onChange={(e)=>{                   

                    }}
                    />
            </div>:''}
            <div className="col-lg-1  my-auto top_select cockpitBTNSeacrth"  style={{ width:'5%'}} >
              <button className="btn" onClick={this.FilterFnc} title='Apply'
                style={{color:'white', backgroundColor:'#00BAF2',height: '36px', borderRadius: '2px'}}>
                <i className="fa fa-search fa-1x" aria-hidden="true"></i>
              </button>
            </div>
        </Row>
       
             
   
        </div>

 

     
     

      
      

      </>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    filterData: state.filter.filterdata,
    products: state.filter.products,
    locations: state.filter.locations,
    periods: state.filter.periods,
    product_att:state.filter.product_att,
    location_att:state.filter.location_att,
  };
};


const mapDispatchToProps = {
  updateFilterData,
  setProducts,
  setLocations,
  setPeriods,
  setProductAtt,
  setLocationAtt,
};
export default connect(mapStateToProps, mapDispatchToProps)(Filter);
// export default Filter
